import React from "react";
import { ArrowRight, MessageSquare } from "lucide-react";
import ChatWidget from "./ChatWidget";

export default function Hero({ onBookDemo, onTryAgent }) {
  return (
    <section id="top" data-testid="hero-section" className="bg-[#0A0F1E]">
      <div className="fs-container fs-section pt-12 md:pt-20">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Left */}
          <div className="lg:col-span-7 fs-reveal">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-8 bg-[#C9A84C]" />
              <span className="fs-tag" data-testid="hero-eyebrow">Always On Sales · by Favor Studio</span>
            </div>

            <h1
              className="font-display text-white text-5xl md:text-7xl lg:text-[5.5rem] leading-[0.92] tracking-[0.02em] uppercase"
              data-testid="hero-headline"
            >
              Stop Losing<br />
              Customers Because<br />
              Nobody Was There<br />
              to Answer.
            </h1>

            <p className="mt-5 font-display text-xl md:text-2xl tracking-[0.05em] uppercase text-white/85" data-testid="hero-tagline">
              Your business, <span className="text-[#C9A84C]">open 24/7.</span> Always on. Always selling.
            </p>

            <p
              className="mt-8 text-lg md:text-xl text-white/65 leading-relaxed max-w-2xl"
              data-testid="hero-subheadline"
            >
              We turn your website into a 24/7 sales representative that answers
              questions, books appointments, and captures leads — even when
              you're closed, busy, or asleep.
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <button data-testid="hero-primary-cta" onClick={onBookDemo} className="btn-primary">
                Book Your Free Demo <ArrowRight size={18} strokeWidth={2} />
              </button>
              <button data-testid="hero-secondary-cta" onClick={onTryAgent} className="btn-secondary">
                <MessageSquare size={17} strokeWidth={1.6} />
                Try the AI Agent Live
              </button>
            </div>

            {/* Stats */}
            <div className="mt-14 grid grid-cols-3 gap-6 md:gap-10 max-w-2xl border-t border-white/10 pt-10">
              <Stat number="24/7" label="Always on, never misses a lead" />
              <Stat number="7 Days" label="From signed contract to live" />
              <Stat number="1 Year" label="Warranty included" />
            </div>
          </div>

          {/* Right — Chat widget */}
          <div id="live-demo" className="lg:col-span-5 fs-reveal" style={{ animationDelay: "150ms" }}>
            <ChatWidget />
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ number, label }) {
  return (
    <div data-testid={`hero-stat-${number.toLowerCase().replace(/\W+/g, "")}`}>
      <div className="font-display text-4xl md:text-5xl text-white tracking-[0.04em]">{number}</div>
      <div className="mt-2 text-xs md:text-[0.78rem] uppercase tracking-[0.18em] text-white/55">{label}</div>
    </div>
  );
}
